import React, { useState } from 'react';
import ComparisonChart from '../components/ComparisonChart';
import NavigationBar from '../components/NavigationBar';
import '../css/Dashboard.css';

const ComparisonChartDemo = () => {
    const [chartData, setChartData] = useState({
        bmi: {
            lastWeek: 26.4,
            current: 25.3,
            unit: '',
            title: 'BMI 비교'
        },
        bloodPressure: {
            lastWeek: 124,
            current: 133,
            unit: 'mmHg',
            title: '혈압 비교'
        },
        bloodGlucose: {
            lastWeek: 95,
            current: 102,
            unit: 'mg/dL',
            title: '혈당 비교'
        }
    });

    const handleValueChange = (type, field, value) => {
        setChartData(prev => ({
            ...prev,
            [type]: {
                ...prev[type],
                [field]: parseFloat(value) || 0
            }
        }));
    };

    return (
        <div className="dashboard-container">
            <NavigationBar />
            <div className="dashboard-content">
                <div className="dashboard-header">
                    <h1>비교 차트 데모</h1>
                    <p>사진에서 보이는 것처럼 오버랩 차트를 구현한 예제입니다.</p>
                </div>

                <div className="dashboard-grid">
                    {/* BMI 차트 */}
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h3>BMI 비교 차트</h3>
                        </div>
                        <div className="card-body">
                            <ComparisonChart
                                lastWeekValue={chartData.bmi.lastWeek}
                                currentValue={chartData.bmi.current}
                                unit={chartData.bmi.unit}
                                title={chartData.bmi.title}
                                lastWeekLabel="지난 주 평균 BMI"
                                currentLabel="현재 평균 BMI"
                            />
                            <div className="chart-controls">
                                <div className="control-group">
                                    <label>지난 주 평균:</label>
                                    <input
                                        type="number"
                                        step="0.1"
                                        value={chartData.bmi.lastWeek}
                                        onChange={(e) => handleValueChange('bmi', 'lastWeek', e.target.value)}
                                    />
                                </div>
                                <div className="control-group">
                                    <label>현재 평균:</label>
                                    <input
                                        type="number"
                                        step="0.1"
                                        value={chartData.bmi.current}
                                        onChange={(e) => handleValueChange('bmi', 'current', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 혈압 차트 */}
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h3>혈압 비교 차트</h3>
                        </div>
                        <div className="card-body">
                            <ComparisonChart
                                lastWeekValue={chartData.bloodPressure.lastWeek}
                                currentValue={chartData.bloodPressure.current}
                                unit={chartData.bloodPressure.unit}
                                title={chartData.bloodPressure.title}
                                lastWeekLabel="지난 주 평균 혈압"
                                currentLabel="현재 평균 혈압"
                            />
                            <div className="chart-controls">
                                <div className="control-group">
                                    <label>지난 주 평균:</label>
                                    <input
                                        type="number"
                                        value={chartData.bloodPressure.lastWeek}
                                        onChange={(e) => handleValueChange('bloodPressure', 'lastWeek', e.target.value)}
                                    />
                                </div>
                                <div className="control-group">
                                    <label>현재 평균:</label>
                                    <input
                                        type="number"
                                        value={chartData.bloodPressure.current}
                                        onChange={(e) => handleValueChange('bloodPressure', 'current', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 혈당 차트 */}
                    <div className="dashboard-card">
                        <div className="card-header">
                            <h3>혈당 비교 차트</h3>
                        </div>
                        <div className="card-body">
                            <ComparisonChart
                                lastWeekValue={chartData.bloodGlucose.lastWeek}
                                currentValue={chartData.bloodGlucose.current}
                                unit={chartData.bloodGlucose.unit}
                                title={chartData.bloodGlucose.title}
                                lastWeekLabel="지난 주 평균 혈당"
                                currentLabel="현재 평균 혈당"
                            />
                            <div className="chart-controls">
                                <div className="control-group">
                                    <label>지난 주 평균:</label>
                                    <input
                                        type="number"
                                        value={chartData.bloodGlucose.lastWeek}
                                        onChange={(e) => handleValueChange('bloodGlucose', 'lastWeek', e.target.value)}
                                    />
                                </div>
                                <div className="control-group">
                                    <label>현재 평균:</label>
                                    <input
                                        type="number"
                                        value={chartData.bloodGlucose.current}
                                        onChange={(e) => handleValueChange('bloodGlucose', 'current', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="dashboard-info">
                    <h3>차트 특징</h3>
                    <ul>
                        <li>두 개의 막대 그래프로 지난 주와 현재 값을 비교</li>
                        <li>상단에 차이값을 오버랩 영역으로 표시</li>
                        <li>점선으로 연결된 시각적 요소</li>
                        <li>증가/감소에 따른 색상 변화</li>
                        <li>실시간 값 변경 가능</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ComparisonChartDemo; 